export const PILL_ICON_TYPE = {
  like: "like",
  comment: "comment",
};
